export function generateRandomColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

export function splitWords(input, max = 4) {
  const words = input.split(' ').slice(0, max);
  const result = [];

  for (let i = 0; i < words.length; i += 2) {
    // Join the current word and the next one if it exists
    const pair = words[i] + (words[i + 1] ? ' ' + words[i + 1] : '');
    result.push(pair);
  }

  return result;
}